import React, { useState, useEffect } from 'react';
import { Section } from '@prosolve/common-components-ui'
import Tabs from '../sharedComponents/Tabs';
// import SessionBlueprintManager from './SessionBlueprintManager/SessionBlueprintManager';
import EventBlueprintList from './EventBlueprintList';
import ModuleBlueprintList from './ModuleBlueprintList';
import { checkHasEditEventTemplatePermissions } from '../../utils';
import { useNavigate } from "react-router-dom";
import useIsMobileView from "../../hooks/useIsMobileView";

export default () => {
  const rawHash = window.location.hash;
  const hash = rawHash.startsWith('#') ? rawHash.slice(1) : rawHash;

  const isMobileView = useIsMobileView();

  const tabs = [
    'Event Templates',
    'Session Templates'
  ];

  const [selectedTab, setSelectedTab] = useState(hash === 'session' ? 'Session Templates' : 'Event Templates')

  const navigate = useNavigate();

  useEffect(() => {
    if (hash) {
      navigate(window.location.pathname + window.location.search);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hash])

  const tabContentMap = {
    'Event Templates': <EventBlueprintList />,
    'Session Templates': <ModuleBlueprintList />
  }

  /*
   * All tab content is created and built on render...we simply show or hide the display based on the tab selected
   */
  const getTabContent = () => {
    return Object.keys(tabContentMap).map(key => 
      <div key={key} style={{ display: (selectedTab === key) ? 'block' : 'none' }}>
        {tabContentMap[key]}
      </div>
    );
  }

  const hasEditEventTemplatePermissions = checkHasEditEventTemplatePermissions()
  if (!hasEditEventTemplatePermissions) {
    return <div></div>
  }

  return (
    <div style={{
      display: 'flex',
      padding: isMobileView ? '5px' :  '5px 20px',
      columnGap: '20px'
    }}>
      <Section style={{ flex: 1, padding: '0px' }}>
        <div
          style={{
            display: 'flex',
            // flexDirection: 'column',
            alignItems: 'center',
            padding: '20px',
            color: '#565656'
          }}
        >
          <div style={{ marginLeft: '10px', fontWeight: 'bold'}}>
            {'ProSolve Design Center'}
          </div>
          <div style={{ marginLeft: '20px', fontStyle: 'italic', fontSize: '14px' }}>
            {'Manage your data for event creation such as event and session templates as seen below'}
          </div>
        </div>
        <Tabs tabs={tabs} selectedTab={selectedTab} setSelectedTab={setSelectedTab} wrapperStyleOverride={isMobileView ? { flexWrap: 'nowrap' } : {}} />
        {getTabContent()}
      </Section>
    </div>
  )
}